import { Link2, ShieldCheck } from "lucide-react";
import { EVENT_LABELS, fmtDate } from "@/lib/ops";

export const CustodyChain = ({ events, integrity }) => (
  <section className="bg-white border border-slate-200 rounded-3xl p-6 sm:p-8" data-testid="custody-chain">
    <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
      <h2 className="flex items-center gap-2 font-semibold text-lg text-[#05130e]"><Link2 className="w-5 h-5 text-[#00b37a]" />Cadena de Custodia Digital</h2>
      {integrity !== undefined && (
        <span className={`flex items-center gap-1 text-xs font-semibold px-3 py-1 rounded-full ${integrity ? "bg-[#00f2a1]/15 text-[#007a50]" : "bg-red-50 text-red-700"}`} data-testid="custody-integrity">
          <ShieldCheck className="w-3.5 h-3.5" />{integrity ? "Registro íntegro" : "Registro alterado"}
        </span>
      )}
    </div>
    <ol className="relative border-l-2 border-[#00f2a1]/40 ml-2 space-y-6">
      {events.map((e) => (
        <li key={e.seq} className="pl-6 relative" data-testid={`custody-event-${e.seq}`}>
          <span className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-[#00f2a1] border-4 border-white" />
          <p className="font-medium text-[#05130e]">{e.seq}. {EVENT_LABELS[e.type] || e.type}</p>
          <p className="text-xs text-slate-500">{fmtDate(e.at)} · {e.actor_razon_social || e.actor || "—"}</p>
          <p className="font-mono text-[10px] text-slate-400 break-all mt-1">hash {e.hash}</p>
        </li>
      ))}
    </ol>
    <p className="text-xs text-slate-500 mt-6">Cada etapa queda sellada con un hash SHA-256 que incluye el hash de la etapa anterior: cualquier alteración posterior rompe la cadena y se detecta en la verificación pública.</p>
  </section>
);
